import { isApiErrorInUse } from '@hprofits/api-client/errors';

import { t } from '@/i18n';

import { buildDeleteMutationErrorOverride, buildSaveMutationErrorOverride } from './shared';

/**
 * Functions, not constants. A module-level string would resolve once at import and pin the
 * wording to whatever language the app booted in; calling through resolves it when the error is
 * actually shown. Renamed from the former UPPER_SNAKE constants in !1545 — same wording, same call sites, one extra `()`.
 */
export const getCampaignLoadErrorMessage = (): string => t('modules.campaigns.mutationErrors.campaign.load');
export const getCampaignLoadErrorDescription = (): string => t('modules.campaigns.mutationErrors.campaign.loadError');
export const getCampaignDuplicateMessage = (): string => t('modules.campaigns.mutationErrors.campaign.duplicate');
export const getCampaignSaveImmutableMessage = (): string =>
  t('modules.campaigns.mutationErrors.campaign.saveImmutable');
export const getCampaignSaveGenericErrorMessage = (): string =>
  t('modules.campaigns.mutationErrors.campaign.saveGeneric');
export const getCampaignAlreadyDeletedMessage = (): string =>
  t('modules.campaigns.mutationErrors.campaign.alreadyDeleted');
export const getCampaignDeleteInUseMessage = (): string => t('modules.campaigns.mutationErrors.campaign.deleteInUse');
export const getCampaignDeleteGenericErrorMessage = (): string =>
  t('modules.campaigns.mutationErrors.campaign.deleteGeneric');

// Built per call, not at import: the builders copy their spec eagerly, so a resolver made at
// module load would freeze the wording to the boot language. Same builder, same spec, same
// result — only the moment of construction moves.
export const getCampaignSaveMutationErrorOverride = (
  ...args: Parameters<ReturnType<typeof buildSaveMutationErrorOverride>>
) =>
  buildSaveMutationErrorOverride({
    duplicateMessage: getCampaignDuplicateMessage(),
    notFoundMessage: getCampaignLoadErrorMessage(),
    immutableMessage: getCampaignSaveImmutableMessage(),
  })(...args);

export const isCampaignDeleteBlockedByDependencies = (error: unknown): boolean => {
  return isApiErrorInUse(error);
};

// Built per call, not at import: the builders copy their spec eagerly, so a resolver made at
// module load would freeze the wording to the boot language. Same builder, same spec, same
// result — only the moment of construction moves.
export const getCampaignDeleteMutationErrorOverride = (
  ...args: Parameters<ReturnType<typeof buildDeleteMutationErrorOverride>>
) =>
  buildDeleteMutationErrorOverride({
    inUseMessage: getCampaignDeleteInUseMessage(),
    notFoundMessage: getCampaignAlreadyDeletedMessage(),
  })(...args);
